<template>
    <div class="class condiciones">                      
        <div class="row mt-3">
            <div class="tab-content col-10 mx-auto pt-4" id="pills-tabContent">
                <div class="tab-pane fade show active" id="seguros" role="tabpanel" aria-labelledby="seguros-tab">
                    <!-- Comienzo cajas pdfs de pólizas de seguros -->
                    <div class="container-grid">

                        <!-- <a href="pdf/seguro.Europ.pdf" target="_blank">
                            <div class="box text-center lift p-3">
                                <div class="p-3">
                                    <img :src="require('@/assets/css/img/logo-europassistance.svg')" alt=""> 
                                </div>
                                <div class="box-content ml-2">
                                    <div class="font-weight-bold">Seguro Asistencia en viaje</div>
                                    <div>Europ Assistance</div>
                                </div>
                            </div>
                        </a> -->
                        
                        <a href="pdf/seguroMapfreIncluido.pdf" target="_blank">
                            <div class="box text-center lift p-3">
                                <div class="p-3">                                    
                                    <img :src="require('@/assets/css/img/logo-mapfre.svg')" alt=""> 
                                </div>
                                <div class="box-content ml-2">
                                    <div class="font-weight-bold">Seguro Incluido</div>
                                    <div>Mapfre</div>
                                </div>
                            </div>
                        </a>
                        <a href="pdf/seguroMapfreOpcional.pdf" target="_blank">
                            <div class="box text-center lift p-3">
                                <div class="p-3">                                    
                                    <img :src="require('@/assets/css/img/logo-mapfre.svg')" alt=""> 
                                </div>
                                <div class="box-content ml-2">
                                    <div class="font-weight-bold">Seguro opcional de cancelación</div>
                                    <div>Mapfre</div>
                                </div>
                            </div>
                        </a>

                    </div>
                    <!-- Fin cajas pdfs de pólizas de seguros -->
                </div>
            </div>                
        </div>
        
    </div>      
</template>

<script>

export default {
    name: 'seguros',
    components: {
        //MenuOpcion,
    },

    data() {
        return {
            titulo: "SEGUROS",
        }
    },
    
}
</script>